/**
 * Formata uma data.
 *
 * Aceita:
 *
 *   - objeto Date
 *   - timestamp (number)
 *   - string no formato 'YYYY-MM-DD HH:mm:ss'
 *   - string no formato 'YYYY-MM-DDTHH:mm:ss.000000Z' (ignora fuso hor�rio)
 *
 * @param valor Data a ser formatada
 * @param {boolean} time Se deve incluir hor�rio
 *
 * @returns {string} Data no formato DD/MM/AAAA HH:mm ou DD/MM/AAAA se time = false
 */
export function formatarData(valor, time = true) {
    if (!valor) return '';

    let data;
    let temSegundos = false;

    // 1. Se j� for Date
    if (valor instanceof Date) {
        data = valor;
    }

    // 2. Timestamp (number)
    else if (typeof valor === 'number') {
        data = new Date(valor);
    }

    // 3. String
    else if (typeof valor === 'string') {
        const isoRegex = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?/;
        const match = valor.match(isoRegex);

        if (match) {
            const [
                ,
                year,
                month,
                day,
                hour = '00',
                minute = '00',
                second
            ] = match;

            temSegundos = second !== undefined;

            data = new Date(
                Number(year),
                Number(month) - 1,
                Number(day),
                Number(hour),
                Number(minute),
                Number(second || 0)
            );
        } else {
            data = new Date(valor);
        }
    }

    if (!data || isNaN(data.getTime())) return '';

    const pad = (n) => String(n).padStart(2, '0');

    const dia = pad(data.getDate());
    const mes = pad(data.getMonth() + 1);
    const ano = data.getFullYear();

    let resultado = `${dia}/${mes}/${ano}`;

    if (time) {
        const hora = pad(data.getHours());
        const minuto = pad(data.getMinutes());

        resultado += ` ${hora}:${minuto}`;

        if (temSegundos) {
            const segundo = pad(data.getSeconds());
            resultado += `:${segundo}`;
        }
    }

    return resultado;
}
